import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import { SearchDropdown } from '@iris-platform/iris-react-ui';
import { withApollo, Query } from 'react-apollo';
import { map } from 'ramda';
import { stylesToPropType } from '../../../utils';
import { GET_TEAMS } from '../queries';

const styles = () => ({
  root: {
    display: 'flex',
    flexFlow: 'column nowrap',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    color: '#282828',
    '& > *': {
      marginTop: '0.4em',
    },
  },
  divider: {
    margin: '2em 0',
  },
  input: {
    marginTop: '0.6em',
    '& input': {
      padding: '0.4em',
      color: '#666666',
    },
  },
  saveButton: {
    borderRadius: '0.125em',
    marginTop: '1em',
    width: '5em',
  },
  scopeSuggestions: {
    display: 'flex',
    flexFlow: 'row wrap',
  },
  helper: {
    display: 'flex',
    height: '28.8px',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    animation: '0.8s slidein',
  },
  '@keyframes slidein': {
    '0%': {
      opacity: '0',
      height: '0',
      marginTop: '0',
      transform: 'scaleY(0)',
      transformOrigin: 'top',
    },
    '100%': {
      opacity: '1',
      transform: 'scaleY(1)',
      transformOrigin: 'top',
    },
  },
});

class TransferTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pendingChanges: false,
      searchDropdownValue: '',
      componentLabel: 'Team',
    };
  }

  transferOwner = (teamList) => {
    const { updateOwner, appId } = this.props;
    const {
      searchDropdownValue,
    } = this.state;

    let ownerId = '';
    Object.keys(teamList).forEach((m) => {
      if (teamList[m] !== undefined) {
        if (teamList[m].display_name === searchDropdownValue) {
          ownerId = teamList[m].team_id;
        }
      }
    });

    updateOwner(ownerId, appId);
    this.setState({ pendingChanges: false, searchDropdownValue: '' });
  }

  render() {
    const { classes } = this.props;
    const {
      searchDropdownValue,
      pendingChanges,
      componentLabel,
    } = this.state;

    return (
      <Query
        query={GET_TEAMS}
        notifyOnNetworkStatusChange
      >
        {({ data, loading, error }) => {
          if (loading) return null;
          if (error) return `Error!: ${error}`;
          const teamList = [...data.teamsForCurrentUser];
          const validTeams = [];
          Object.keys(data.teamsForCurrentUser).forEach((m) => {
            if (data.teamsForCurrentUser[m] !== undefined) {
              validTeams.push(data.teamsForCurrentUser[m].display_name);
            }
          });

          return (
            <FormControl className={classes.root} error={error}>
              <Typography
                component="div"
                variant="caption"
                gutterBottom
              >
                {componentLabel}
              </Typography>
              <SearchDropdown
                value={searchDropdownValue}
                placeholder="Enter team name"
                optionsList={map(option => ({ description: option }), validTeams)}
                onChange={value => this.setState({
                  searchDropdownValue: value.description,
                  pendingChanges: true,
                })}
                onSelect={value => this.setState({
                  searchDropdownValue: value.description,
                  pendingChanges: true,
                })}
              />
              <br />
              <Button
                variant="contained"
                classes={{ root: classes.saveButton }}
                disabled={!pendingChanges}
                onClick={() => this.transferOwner(teamList)}
              >
                Transfer
              </Button>
            </FormControl>
          );
        }}
      </Query>
    );
  }
}

TransferTab.propTypes = {
  classes: stylesToPropType(styles()).isRequired,
  updateOwner: PropTypes.func.isRequired,
  appId: PropTypes.string.isRequired,
  client: PropTypes.object.isRequired,
};

export default withApollo(withStyles(styles)(TransferTab));
